import { Heading } from '../Heading';
import { Para } from '../Para';
import { Stack } from '../Stack';
import { ErrorPageContainer } from './ErrorPageContainer';

export function Error404(): React.ReactElement {
  return (
    <ErrorPageContainer title="Seite nicht gefunden (404)">
      <Stack gap={6}>
        <Heading variant="h2" align="left">
          Seite nicht gefunden!
        </Heading>

        <Para>
          Hallo und willkommen im vermutlich exklusivsten Bereich unserer Webseite. Denn kein Link,
          kein Banner und keine Empfehlung führt auf diese 404-Seite. Die hast Du ganz allein
          gefunden.
        </Para>

        <Para>
          Spass beiseite, leider wurde diese Seite nicht gefunden. Das tut uns leid! Versuch es doch
          gerne nochmal.
        </Para>
      </Stack>
    </ErrorPageContainer>
  );
}
